import { type RequestedDataGroup } from '../../hooks/useRequestedData';

/** EmbeddedRequestedDataCard — "What is shared": each group with its attribute names. */
export default function EmbeddedRequestedDataCard({
  label,
  groups,
}: {
  label: string;
  groups: RequestedDataGroup[];
}) {
  return (
    <div className="flex w-full flex-col gap-2.5 rounded-[10px] bg-muted px-3.5 py-3">
      <span className="text-xs font-semibold tracking-[0.02em] text-muted-foreground uppercase">
        {label}
      </span>
      {groups.map((group) => (
        <div key={group.credentialUuid} className="flex items-start gap-2.5">
          <span
            aria-hidden="true"
            className="mt-0.5 size-4 shrink-0 rounded-full bg-border"
          />
          <span className="flex min-w-0 flex-col">
            <span className="font-semibold">{group.name}</span>
            <span className="text-[13px] leading-[18px] text-muted-foreground">
              {group.fields.map((f) => f.name).join(', ')}
            </span>
          </span>
        </div>
      ))}
    </div>
  );
}
